<p-dialog
  [(visible)]="displayAddNewTemplateModal"
  [modal]="false"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="true"
  styleClass="order-dialog">
  <ng-template pTemplate="header">
    <div class="header-modal pb-4 has-border w-100 d-flex align-items-center">
      <h2 class="me-2">Add Template</h2>
    </div>
  </ng-template>
  <form [formGroup]="parentForm">
    <div class="row pt-3">
      <div class="col">
        <div class="form-group has-float-label mb-4">
          <label class="form-label" for="type">Title<span>*</span></label>
          <input
            jniAutoCompleteBlocker
            class="form-control"
            type="text"
            formControlName="title" />
        </div>
      </div>
      <div class="col">
        <div class="form-group has-float-label mb-4">
          <label class="form-label" for="type">Tags <span>*</span></label>
          <p-select
            #tagSelector
            class="custom-ng-select"
            [(ngModel)]="tagValue"
            formControlName="tags"
            notFoundText="No Tags Found"
            (onChange)="onChangeAddTag(emailEditor, $event)"
            [filter]="true"
            [showClear]="true"
            [options]="tagList">
          </p-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group has-float-label mb-4">
          <label class="form-label" for="descp">Description</label>
          <p-editor
            formControlName="description"
            #emailEditor
            ngDefaultControl
            (click)="getCursorPostion(emailEditor)"
            [(ngModel)]="notificationEmailData.content"
            id="email-editor"
            [style]="{ height: '200px' }"></p-editor>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="d-flex py-3 justify-content-end has-sticky gap-3">
      <p-button
        label="Cancel"
        (click)="closeAddNewTemplateDialog()"
        variant="outlined"
        severity="secondary" />

      <p-button
        label="Add"
        (click)="saveAddNewTemplate()"
        [disabled]="!parentForm.valid" />
    </div>
  </ng-template>
</p-dialog>
